
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { MatchingData } from "@/lib/types";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";

interface DataDisplayProps {
  matchingData: MatchingData | null;
}

const DataDisplay = ({ matchingData }: DataDisplayProps) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (!matchingData) {
    return null;
  }

  return (
    <div className="border rounded-lg shadow-sm mt-8">
      <div 
        className="flex items-center justify-between p-4 bg-gray-50 border-b cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center">
          {isExpanded ? (
            <ChevronDown className="h-4 w-4 mr-2 text-gray-500" />
          ) : (
            <ChevronRight className="h-4 w-4 mr-2 text-gray-500" />
          )}
          <h3 className="font-medium">
            Matching Data from <span className="font-semibold">{matchingData.sheet}</span>
          </h3>
        </div>
        <div className="text-sm text-gray-500">
          {matchingData.rows.length} rows
        </div>
      </div>
      
      {isExpanded && (
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                {matchingData.headers.map((header, index) => (
                  <TableHead key={index}>{header}</TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {matchingData.rows.map((row, rowIndex) => (
                <TableRow key={rowIndex} className="bg-white hover:bg-blue-50 transition-colors">
                  {row.map((cell, cellIndex) => (
                    <TableCell key={cellIndex}>{cell.toString()}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          
          {matchingData.rows.length === 0 && (
            <div className="p-4 text-center text-gray-500">
              No matching data found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DataDisplay;
